module.exports = __webpack_public_path__ + "img/photos/avatars/01@2x.jpg";